// extracted by mini-css-extract-plugin
export default {"container":"style_container__zonAj","track":"style_track__5QrM-","slide":"style_slide__wsBC8","overlay":"style_overlay__sazc2","title":"style_title__waUKX"};